import { message, Modal, Spin, Table as TableAntd, Flex } from 'antd';
import { Formik, FieldArray } from 'formik';
import { Input } from 'formik-antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormControl from '~/components/Form/FormControl';
import { FaPlus } from 'react-icons/fa';
import { ModalFooter } from '~/components/Modal';
import Row from '~/components/Row';
import { createCardsOperator, updateCardsOperator } from '~/services/hooks/cardsOperator';
import { useCheckAuth } from '~/components/Can/checkAuth';
import { Table } from '~/components/Table';
import { cardsModalitysColumns } from '~/tables/cards';
import Button from '~/components/Button';
import errorHandler from '~/Utils/errorHandler';

const initial = {
  name: null,
  cards: [],
};

export default function CardModal({ visible, onClose, cardEdit, isMobile }) {
  const { t } = useTranslation();
  const authCheck = useCheckAuth();
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(initial);

  const fluidPermissions = () => {
    if (cardEdit) {
      return authCheck('@cards/edit');
    } else {
      return authCheck('@cards/create');
    }
  };

  const saveCards = async (values, { setErrors }) => {
    setLoading(true);
    try {
      if (cardEdit) {
        await updateCardsOperator(values.id, values);
        message.success(t('messages:cards.successPut'));
      } else {
        await createCardsOperator(values);
        message.success(t('messages:cards.successPost'));
      }
      onClose();
    } catch (error) {
      console.error(error);
      setErrors(errorHandler(error));
    }
    setLoading(false);
  };

  useEffect(() => {
    if (visible) {
      if (cardEdit) {
        setInitialValues(cardEdit);
      }
    }
  }, [visible]);

  return (
    <Formik
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize
      initialValues={initialValues}
      onSubmit={saveCards}
    >
      {({ isSubmitting, submitForm, values, errors }) => (
        <Modal
          title={t(cardEdit ? 'screens:cards.titlePut' : 'screens:cards.titlePost') + (values.name ?? '')}
          onCancel={onClose}
          style={{ maxWidth: isMobile ? '100%' : '1500px' }}
          afterClose={() => setInitialValues(initial)}
          open={visible}
          centered
          width="800px"
          footer={<ModalFooter onOk={submitForm} loading={loading || isSubmitting} onCancel={onClose} />}
        >
          <Spin spinning={loading}>
            <Row>
              <FormControl cols={{ xs: 12 }} field="name" label={t('fields:card_operator.name')}>
                <Input name="name" disabled={!fluidPermissions()} />
              </FormControl>
            </Row>
            <FieldArray name="cards">
              {({ push, remove }) => (
                <Table
                  dataSource={values?.cards?.map((c, i) => ({
                    ...c,
                    key: i,
                    remove,
                  }))}
                  columns={cardsModalitysColumns(errors, fluidPermissions)}
                  size="small"
                  rowClassName={() => 'editable-row'}
                  bordered
                  empty={false}
                  summary={() => {
                    return (
                      <TableAntd.Summary.Row>
                        <TableAntd.Summary.Cell>
                          <Flex style={{ height: '100%' }} align="flex-start" justify="center">
                            <Button
                              color="primary"
                              title="Adicionar modalidade"
                              size="small"
                              onClick={() => push({ card_type: null, fee: null })}
                              style={{ width: '30px' }}
                              disabled={!fluidPermissions()}
                            >
                              <FaPlus />
                            </Button>
                          </Flex>
                        </TableAntd.Summary.Cell>
                      </TableAntd.Summary.Row>
                    );
                  }}
                />
              )}
            </FieldArray>
          </Spin>
        </Modal>
      )}
    </Formik>
  );
}
